import { render, staticRenderFns } from "./DatatableV1.vue?vue&type=template&id=cacd5d20&scoped=true&"
import script from "./DatatableV1.vue?vue&type=script&lang=js&"
export * from "./DatatableV1.vue?vue&type=script&lang=js&"
import style0 from "./DatatableV1.vue?vue&type=style&index=0&id=cacd5d20&prod&scoped=true&lang=css&"
import style1 from "./DatatableV1.vue?vue&type=style&index=1&id=cacd5d20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacd5d20",
  null
  
)

export default component.exports